import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:3001";

const FeeStructureUploadService = {
  // =========================================================
  // VALIDATE UPLOAD
  // =========================================================
  validateFeeStructureUpload: async (file, clientId, collegeId) => {
    const formData = new FormData();
    formData.append("file", file);

    return axios.post(
      `${API_BASE_URL}/api/fee-structure-upload/${clientId}/${collegeId}/validate`,
      formData
    );
  },

  // =========================================================
  // IMPORT UPLOAD
  // =========================================================
  importFeeStructureUpload: async (payload) => {
    const { client_id, college_id } = payload;

    return axios.post(
      `${API_BASE_URL}/api/fee-structure-upload/${client_id}/${college_id}/import`,
      payload
    );
  },

  // =========================================================
  // ADMITTED BATCH SUMMARY
  // =========================================================
  getAdmittedBatchFeeStructureSummary: async (clientId, collegeId) => {
    return axios.get(
      `${API_BASE_URL}/api/fee-structure-upload/${clientId}/${collegeId}/admitted-batches`
    );
  },

  // =========================================================
  // FEE STRUCTURE DETAILS BY BATCH
  // =========================================================
  getFeeStructuresByAdmittedBatch: async (clientId, collegeId, admittedbatchId) => {
    return axios.get(
      `${API_BASE_URL}/api/fee-structure-upload/${clientId}/${collegeId}/admitted-batch/${admittedbatchId}`
    );
  },

  // =========================================================
  // DOWNLOAD FEE STRUCTURE PDF
  // =========================================================
  downloadFeeStructurePdf: async (clientId, collegeId, admittedbatchId) => {
    return axios.get(
      `${API_BASE_URL}/api/fee-structure-upload/${clientId}/${collegeId}/admitted-batch/${admittedbatchId}/pdf`,
      {
        responseType: "blob",
      }
    );
  },
  // =========================================================
  // WORKFLOW SUMMARY
  // =========================================================
  getWorkflowSummary: async (clientId, collegeId, workflowStatus) => {
    return axios.get(
      `${API_BASE_URL}/api/fee-structure-upload/${clientId}/${collegeId}/workflow-summary/${workflowStatus}`
    );
  },

  // =========================================================
  // WORKFLOW DETAILS BY ADMITTED BATCH
  // =========================================================
  getWorkflowFeeStructures: async (clientId, collegeId, admittedbatchId, workflowStatus) => {
    return axios.get(
      `${API_BASE_URL}/api/fee-structure-upload/${clientId}/${collegeId}/admitted-batch/${admittedbatchId}/workflow/${workflowStatus}`
    );
  },

  // =========================================================
  // APPROVE / REJECT SELECTED FEE STRUCTURES
  // =========================================================
  updateWorkflowStatus: async (clientId, collegeId, payload) => {
    return axios.patch(
      `${API_BASE_URL}/api/fee-structure-upload/${clientId}/${collegeId}/workflow-status`,
      payload
    );
  },
};

export default FeeStructureUploadService;
